import React, { useState } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { Button, Flex, Modal } from 'antd';
import { toast } from 'react-toastify';
import { Organization } from 'src/interfaces/entities/organization';
import { useDeleteOrganizationMutation } from 'src/redux/services/centralApi';
import { User } from 'src/interfaces/entities/user';

export default function DeleteOrganization(
	{
		row,
	}: { row: Organization & { users: User[], jwt: string }}
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ deleteOrganization, deleteOrganizationResult, ] = useDeleteOrganizationMutation();

	return <>
		<Button
			type="text"
			danger
			icon={<DeleteOutlined />}
			onClick={() => setOpen(true)}
		/>
		<Modal
			centered
			title={'Excluir Organização'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			okText="Excluir"
			onOk={() => {
				deleteOrganization({ id: row.id, })
					.unwrap()
					.then(() => {
						toast.success('Organização excluída com sucesso!', {
							autoClose: 1000,
						});
					})
					.catch((err) => {
						if (err?.status && err?.status === 500
							&& err?.data?.frontend_message) {
							toast.error(err?.data?.frontend_message, {
								autoClose: 1000,
							});
						}
					})
					.finally(() => {
						setOpen(false);
					});
			}}
			confirmLoading={deleteOrganizationResult.isLoading}
		>
			<Flex>
				{`Tem certeza que deseja deletar a organização: ${row.name}`}
			</Flex>
		</Modal>
	</>;
}